<template>
  <div class="media-box">
    <div class="image">
      <a :href="link" target="_blank">
        <img :src="imageUrl" />
      </a>
    </div>
    <div class="content">
      <h3>{{ title }}</h3>
      <div class="text">
        <slot></slot>
      </div>
      <div class="btn-wrap dark-blue-btn">
        <a :href="link" target="_blank">Read Full Article</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'media-box',
  props: {
    title:{
      default:'',
      type:String
    },
    link:{
      default:'',
      type:String
    },
    imageSource: {
      default:'',
      type:String
    }
  },
  computed: {
    imageUrl() {
      return require('../../../assets/images/'+this.imageSource)
    }
  }
}
</script>

<style scoped>
.media-section {
  padding: 50px 0;
}
.media-section .container {
  max-width: 1440px;
}
.media-section .section-title .text p {
  margin: 40px 0;
}
.media-section .media-box {
  display: flex;
  margin-bottom: 70px;
}
.media-section .media-box:last-child {
  margin-bottom: 0;
}
.media-section .media-box .image {
  width: 450px;
}
.media-section .media-box .image a {
  display: inline-block;
  vertical-align: top;
  width: 100%;
}
.media-section .media-box .content {
  width: calc(100% - 450px);
  padding-left: 40px;
}
.media-section .media-box .content .text {
  margin: 40px 0;
}
.media-section .media-box .content .text h4 {
  margin-bottom: 15px;
}
.media-section .media-box .dark-blue-btn a {
  min-width: 200px;
}
@media (max-width: 991px) {
  .media-section .media-box .image {
    width: 350px;
  }
  .media-section .media-box .content {
    width: calc(100% - 350px);
  }
  .media-section .media-box .content .text {
    margin: 20px 0;
  }
}

@media (max-width: 767px) {
  .media-section .section-title .text p {
    margin-top: 20px;
  }
  .media-section .media-box {
    display: block;
  }
  .media-section .media-box .content {
    width: 100%;
    padding: 30px 0 0;
  }
}

@media (max-width: 575px) {
  .media-section .media-box .image {
    width: 270px;
  }
}
</style>